import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { DocumentRequirements } from './DocumentRequirements/DocumentRequirements';
import { FlexiLoanFeatures } from './FlexiLoanFeatures/FlexiLoanFeatures';
import { FlexiLoanProcess } from './FlexiLoanProcess/FlexiLoanProcess';
import { IwocaPayWidget } from './IwocaPayWidget/IwocaPayWidget';
import styles from './Products.module.css';
import { ProductsSkeleton } from './ProductsSkeleton/ProductsSkeleton';

export const Products = () => {
  const { isContextLoading, isIntroducerLoading } = useIntroducerData();

  if (isContextLoading || isIntroducerLoading) {
    return <ProductsSkeleton />;
  }

  return (
    <div id="products-page" className={styles.container}>
      <FlexiLoanFeatures />
      <DocumentRequirements />
      <FlexiLoanProcess />
      <IwocaPayWidget />
    </div>
  );
};
